import styled from 'styled-components';

import type {
  ThemeType,
} from '@n3/css-base';

export const getCollapserHeight = ({
  indents,
}: ThemeType) => 2 * indents.INDENT_2 + 16;
export const ITEM_HEIGHT = 40;
export const ICON_WIDTH = 50;
export const COUNTER_POINT_WIDTH = 8;

export const StyledTitleIcon = styled.div<{
  $isActive: boolean;
  $isMenuVisible: boolean;
}>(({
  $isActive,
  $isMenuVisible,

  theme: {
    colors,
    sidebar,
  },
}) => {
  const colorKey = $isMenuVisible
    ? $isActive
      ? sidebar.ICON_COLOR_OPENED_ACTIVE
      : sidebar.ICON_COLOR_OPENED_INACTIVE
    : $isActive
      ? sidebar.ICON_COLOR_CLOSED_ACTIVE
      : sidebar.ICON_COLOR_CLOSED_INACTIVE;

  return {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexBasis: ICON_WIDTH,
    color: colors[colorKey],
  };
});

export const StyledCounterPoint = styled.div<{ $isError?: boolean }>(({
  $isError,

  theme: {
    colors,
  },
}) => ({
  boxSizing: 'border-box',
  position: 'absolute',
  top: 5,
  right: 5,
  width: COUNTER_POINT_WIDTH,
  height: COUNTER_POINT_WIDTH,
  borderRadius: COUNTER_POINT_WIDTH / 2,
  backgroundColor: $isError ? colors.SUPPORT_ERROR_INVERSE : colors.ACTION_DEFAULT,
}));

export const StyledCounter = styled.div({
  display: 'flex',
  alignItems: 'center',
});

export const StyledTitleText = styled.div({
  flex: 1,
  display: 'flex',
  alignItems: 'center',
  overflow: 'hidden',
  wordBreak: 'break-word',
  wordWrap: 'break-word',
  paddingTop: 4,
  paddingBottom: 4,
});
